module.exports = __webpack_public_path__ + "static/media/s_v10_t2.f1de890c.mp3";